class Recipient {
    constructor(data) {
        this.id = data.id || null
        this.currency_code = data.currency_code || null
        this.payment_system_code = data.payment_system_code || null
        this.bank_code = data.bank_code || null
        this.fields = data.fields || {}
    }

    toObject() {
        return {
            id: this.id,
            currency_code: this.currency_code,
            payment_system_code: this.payment_system_code,
            bank_code: this.bank_code,
            fields: this.fields
        }
    }
}

class RecipientList {
    static BANK_FILTER_PAYMENT_SYSTEM_CODES = [
        'card',
        'sbp',
        'swift',
        'atm',
        'stock',
        'courier',
        'crypto',
        'office',
        'chat'
    ]

    constructor(list) {
        this.items = (list || []).map(item => new Recipient(item))
    }

    toArrayObj() {
        return this.items.map(item => item.toObject())
    }

    // Получение списка из Vuex стора
    static GetListFromStore(store) {
        if (!store) return []
        if (!(store instanceof Object)) return []
        return store.getters.GetRecipients || []
    }

    // Получение данных с API
    static async FetchFromApi(store) {
        const res = await store.dispatch('GetRecipients')
        if (res && res.data && Array.isArray(res.data)) {
            const arr = res.data.map(item => (item instanceof Recipient ? item.toObject() : new Recipient(item).toObject()))
            try { store.commit('SetRecipients', arr) } catch {}
            return arr
        }
        return []
    }

    // Получение списка с проверкой в сторе и запросом к API
    static async GetList(store) {
        let list = this.GetListFromStore(store)
        if (!list || !list.length) {
            list = await this.FetchFromApi(store)
        }
        return list
    }

    static ToObjectMap(array){
        if(!array || !Array.isArray(array)) return {}
        let recipients_obj = {}
        for(let i = 0; i < array.length; i++){
            if(!array[i].id) continue
            recipients_obj[array[i].id] = array[i]
        }
        return recipients_obj
    }

    // Фильтрует получателей по валюте, банку и (опционально) платёжной системе
    static FilterRecipients(recipients, currency_code, allowed_bank_codes, allowed_pay_sys_codes = []) {
        if(!recipients || !Array.isArray(recipients)) return []
        if(!currency_code) return []
        const bankFilterCodes = this.BANK_FILTER_PAYMENT_SYSTEM_CODES
        const hasAllowedBankCodes = Array.isArray(allowed_bank_codes) && allowed_bank_codes.length > 0
        const hasAllowedPaySysCodes = Array.isArray(allowed_pay_sys_codes) && allowed_pay_sys_codes.length > 0
        return recipients.filter(recipient => {
            const payCode = recipient.payment_system_code || null
            const bankCode = recipient.bank_code || null
            const curCode = recipient.currency_code || null
            const requiresBankFilter = !!(payCode && bankFilterCodes.includes(payCode))

            const byCurrency = curCode && curCode === currency_code
            const byBank = !requiresBankFilter || (hasAllowedBankCodes && bankCode && allowed_bank_codes.includes(bankCode))
            const byPaySys = !hasAllowedPaySysCodes || (payCode && allowed_pay_sys_codes.includes(payCode))
            return byCurrency && byBank && byPaySys
        })
    }
}

export { Recipient, RecipientList }